import { render } from "./SubmissionFilterBasic.vue?vue&type=template&id=25da565c"
import script from "./SubmissionFilterBasic.vue?vue&type=script&lang=js"
export * from "./SubmissionFilterBasic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__